import {createStyles} from '@mantine/core';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

import PMEISidePanelContent from './PMEISidePanelContent';
import PMEISidepanelHeader from './PMEISidepanelHeader';
import usePMEISidepanelDetail from './usePMEISidepanelDetail';
import {UnitOperationFields} from './useUnitOpLinkingState';

const useStyles = createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});

export default function PMEISidePanel({unitOperation}: {unitOperation: UnitOperationFields}): JSX.Element {
  const detail = usePMEISidepanelDetail(unitOperation.pmeiId);
  const {classes} = useStyles();

  return (
    <div className={classes.root} {...getTestProps({component: 'PMEISidePanel', element: 'root'})}>
      <PMEISidepanelHeader unitOperation={unitOperation} />
      <PMEISidePanelContent detailData={detail.data} loading={detail.loading} />
    </div>
  );
}
